'use client';

import { useEffect, useState } from 'react';

/**
 * This code is copied and modified from the following source:
 * Author: uidotdev/usehooks https://usehooks.com/
 * Source: https://github.com/uidotdev/usehooks/blob/main/index.js#L543-L551
 * License: MIT https://github.com/uidotdev/usehooks/blob/main/LICENSE
 */

/**
 * Hook that detects whether the code is running on the client-side (browser) or server-side.
 * Starts as false during SSR and becomes true after hydration. Useful for conditional rendering
 * of client-only components or preventing hydration mismatches.
 *
 * @returns {boolean} True if running in the browser after hydration, false during SSR.
 */
export const useIsClient = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // oxlint-disable-next-line react/set-state-in-effect -- Hydration status intentionally changes after mount.
    setIsClient(true);
  }, []);

  return isClient;
};
